import {LucideMonitorSmartphone} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'paired-devices',
    children: [
      {
        path: '',
        loader: protectedLoader('TASKS', 'MANAGE_PAIRED_DEVICES'),
        async lazy() {
          const {PairedDeviceListPage} = await import(
            './pages/PairedDeviceListPage.tsx'
          );
          return {
            element: <PairedDeviceListPage />,
          };
        },
        children: [
          {
            path: ':id',
            loader: protectedLoader('TASKS', 'MANAGE_PAIRED_DEVICES'),
            async lazy() {
              const {EditPairedDevicePage} = await import(
                './pages/EditPairedDevicePage.tsx'
              );
              return {
                element: <EditPairedDevicePage />,
              };
            },
          },
        ],
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/paired-devices',
    text: i18n.t('Devices'),
    icon: <LucideMonitorSmartphone />,
    permission: 'MANAGE_PAIRED_DEVICES',
    entitlement: 'TASKS',
  },
] as MenuItemElement[];
